export const normalizeProposal = (proposal) => {
  return {
    id: proposal.id,
    name: proposal.name,
    email: proposal.email,
    documentNumber: proposal.documentNumber,
    phoneNumber: proposal.phoneNumber,
    companyDocument: proposal.companyDocument,
    companyLegalName: proposal.companyLegalName,
    cnpjConsigneeId: proposal.cnpjConsigneeId,
    cnpjConsigneeName: proposal.cnpjConsigneeName,
    created: proposal.created,
    type: proposal.type,
    status: proposal.status,
    url: proposal.url,
    proposalNumber: proposal?.proposalNumber,
    loanDetails: proposal.loanDetails.map((loan) => ({
      loanType: loan.loanType,
      proposalNumber: loan.proposalNumber,
      purchaseMargin: Number((loan?.purchaseMargin * 100).toFixed()),
    })),
    purchaseMargin: Number((proposal?.purchaseMargin * 100).toFixed()),
    documents: proposal.documents,
    loanType: proposal.loanType,
  };
};
